import stateClass from '../baseState';
import {MessageState} from '../messageBar/state';

const AUTH_CHANGE_EVENT = 'auth_change_event';
const AUTH_WINDOW_CHANGE_EVENT = 'auth_window_change_event';

const AUTH_SUCC_TXT = 'Autorizācija veiksmīga';
const AUTH_FAIL_TXT = 'Nepareizs lietotājs vai parole';

class UserClass extends stateClass {
	
	constructor(props) {

		super(props);

		this.auth = false;
		this.authWindow = false;
		this.loginMessage = '';
		this.token = '';
	}

	isAuthorized() {

		return this.auth;
	}

	getAuthWindowState() {

		return this.authWindow;
	}

	getMessage() {

		return this.loginMessage;
	}

	setAuthWindow(bol) {

		this.authWindow = bol;
		this.emit(AUTH_WINDOW_CHANGE_EVENT);
	}

	login(data) {

		$.post('/authorize', data, (response) => {

			if(response.result) {

				this.auth = true;
				this.authWindow = false;
				this.loginMessage = null;
				this.token = response.token;

				MessageState.update(AUTH_SUCC_TXT);
			} else if (response.message){

				this.loginMessage = response.message;
				this.auth = false;
			} else {

				this.loginMessage = AUTH_FAIL_TXT;
				this.auth = false;
			}
			
			this.emit(AUTH_CHANGE_EVENT);

		}, 'json');

	}
}

var UserState = new UserClass();

export {UserState, AUTH_CHANGE_EVENT, AUTH_WINDOW_CHANGE_EVENT};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/user/state.js